import { defineMessages } from 'react-intl';

export const messages: {
	selectAppCheckboxLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	selectAppCheckboxLabel: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.apps-group.apps-group-item.select-app-checkbox-label',
		description: 'Accessible label for the checkbox to select an app in the more apps list.',
		defaultMessage: 'Select {appName}',
	},
});
